/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ads_Dialog_No_ToolsInputs */

const en_directory_ads_dialog_no_tools = /** @type {(inputs: Directory_Ads_Dialog_No_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You need a published listing before booking an ad week.`)
};

const zh_directory_ads_dialog_no_tools = /** @type {(inputs: Directory_Ads_Dialog_No_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预订广告周前，你需要先有一个已发布的 listing。`)
};

/**
* | output |
* | --- |
* | "You need a published listing before booking an ad week." |
*
* @param {Directory_Ads_Dialog_No_ToolsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ads_dialog_no_tools = /** @type {((inputs?: Directory_Ads_Dialog_No_ToolsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ads_Dialog_No_ToolsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ads_dialog_no_tools(inputs)
	return zh_directory_ads_dialog_no_tools(inputs)
});
export { directory_ads_dialog_no_tools as "directory.ads.dialog_no_tools" }